import { render, staticRenderFns } from "./LocationInfo.vue?vue&type=template&id=0b4c9147"
import script from "./LocationInfo.vue?vue&type=script&lang=js"
export * from "./LocationInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b4c9147')) {
      api.createRecord('0b4c9147', component.options)
    } else {
      api.reload('0b4c9147', component.options)
    }
    module.hot.accept("./LocationInfo.vue?vue&type=template&id=0b4c9147", function () {
      api.rerender('0b4c9147', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/schedule/LocationInfo.vue"
export default component.exports